<mat-form-field id="inputCOMP-form" [formGroup]="group" class="col-md-6 custom-form-field">
  <mat-label>{{ field.displayName }}</mat-label>
  <input
    matInput
    [formControlName]="field.name"
    [name]="field.name"
    [readonly]="field.readonly"
    [type]="field.inputType"
    autocomplete="off"
    [required]="requiredBool"
    (click)="browse.click()"
    (keyup.enter)="browse.click()"
    tabindex="0"
  />
  <!-- <input *ngIf="field.inputType === 'number' " matInput [formControlName]="field.name" [name]="field.name" onkeydown="javascript: return  event.keyCode === 190 || event.keyCode === 8 || event.keyCode === 46 ? true : !isNaN(Number(event.key))"
    [placeholder]="field.displayName" [type]="field.inputType" autocomplete="off" [required]="requiredBool" /> -->
  @for (validation of field.validations; track validation) {
    <ng-container id="inputCOMP-form-ng-container" ngProjectAs="mat-error">
      @if (group.get(field.name).hasError(validation.name)) {
        <mat-error id="inputCOMP-form-error{{ field.name }}">{{ validation.message }}</mat-error>
      }
      <!-- <mat-error id="inputCOMP-form-error{{field.name}}" *ngIf="group.get(field.name).hasError('customError')">Email Id already exists</mat-error> -->
    </ng-container>
  }
</mat-form-field>
<button #browse class="browseBtn col-md-2" (click)="openDialog()" (keyup.enter)="openDialog()" tabindex="0">
  Browse
</button>
